import gql from 'graphql-tag';

export const testimonialsQuery = gql`
  query GetTestimonials {
    testimonialSection {
      displayText
      subtitle
      bag {
        contentItems {
          ... on Testimonials {
            clientName
            clientTitle
            quote
          }
        }
      }
    }
  }
`;